import {SiteEntity, SiteSelectorProps, sitesSelector, useGetAllSitesQuery} from "@ots-frontend/ots-data";
import {BaseSiteSelect, BaseSiteSelectProps} from "./BaseSiteSelect";
import {useCallback, useMemo, useState} from "react";
import {Button, Modal, ModalProps, Stack} from "@mantine/core";
import {useTranslation} from "react-i18next";
import {useForm} from "@mantine/form";

export type SiteSelectProps = Omit<BaseSiteSelectProps, "entities" | "loading"> & {
  selector?: SiteSelectorProps
}

export const SiteSelect = (props: SiteSelectProps) => {
  const {selector, ...rest} = props;

  const selectSites = useMemo(() => {
    return sitesSelector()
  }, []);

  const {sites, isLoading} = useGetAllSitesQuery(selector?.regionId, {
    selectFromResult: (result) => ({
      sites: selectSites(result, selector),
      isLoading: result.isLoading
    })
  });

  return <BaseSiteSelect entities={sites} loading={isLoading} {...rest} />;
};

export interface SiteSelectModalProps extends Omit<ModalProps, "onSubmit"> {
  select?: SiteSelectProps,
  selector?: SiteSelectorProps,
  onSubmit?: (sites: SiteEntity[] | undefined) => void
}

export const SiteSelectModal = (props: SiteSelectModalProps) => {
  const {
    select,
    onSubmit,
    ...rest
  } = props;

  const [selectedSites, setSelectedSites] = useState<SiteEntity[]>([])

  const {t} = useTranslation(["common"]);

  const form = useForm({
    initialValues: {
      site: undefined,
    },
    validate: {}
  });

  const onFormSubmit = useCallback(async (values: typeof form.values) => {
    if (onSubmit) {
      // noop
    }
  }, [form, onSubmit]);

  return (
    <Modal {...rest}>
      <form onSubmit={form.onSubmit(onFormSubmit)}>
        <Stack spacing="md">
          <SiteSelect
            label={t("common.entity.site", "Site")}
            placeholder={t("common.entity.site", "Site")}
            withinPortal={true}
            clearable
            onEntityChange={e => setSelectedSites(e)}
            selector={select?.selector}
            {...form.getInputProps("site")} />
          <Button type="submit" mt="xl" onClick={(e) => {
            if (onSubmit) {
              onSubmit(selectedSites);
            }
          }}>
            {t("common.action.submit")}
          </Button>
        </Stack>
      </form>
    </Modal>
  );
};
